export enum Token {
    TOKEN = 'APP_TOKEN',
    REFRESH_TOKEN = 'APP_REFRESH_TOKEN',
}
